import { defineStore } from 'pinia';
import Authentication from 'src/boot/services/Authentication';
import Objectives from 'src/boot/services/Objectives';
import {
  FetchHistoryParams,
  FetchObjectivesParams,
  Objective,
  ObjectiveFilter,
  ObjectiveHistoryStore,
  ObjectiveWhere,
} from 'src/types';

export const useQuestions = defineStore('questions', {
  state: () => ({
    defaultMinMaxYears: [1999, 2022],
    jury: [] as string[] | undefined,
    totalCount: 0,
    totalCountWrong: 0,
    countResult: 0,
    countWrongResult: 0,
    isLoadingYears: true,
    isLoadingJury: true,
    subjects:
      Authentication.loggedUser()?.contest.subjects.map((el) => el.subject) ||
      [],
    questions: [] as Objective[],
    currentQuestion: {} as Objective,
    userHistories: [] as ObjectiveHistoryStore[],
    newHistories: [] as ObjectiveHistoryStore[],
  }),
  getters: {
    getMinYears(): number {
      return this.defaultMinMaxYears[0];
    },
    getMaxYears(): number {
      return this.defaultMinMaxYears[1];
    },
  },
  actions: {
    async fetchObjectivesYears() {
      this.isLoadingYears = true;
      const response = await Objectives.fetchYears();
      if (response) {
        const years = response.data._items;
        const min = Math.min(...years);
        const max = Math.max(...years);
        this.$state.defaultMinMaxYears = [min, max];
      }
      this.isLoadingYears = false;
      return this.$state.defaultMinMaxYears;
    },
    async fetchObjectivesJury() {
      this.isLoadingJury = true;
      const response = await Objectives.fetchJury();
      this.$state.jury = response?._items;
      this.isLoadingJury = false;
      return this.$state.defaultMinMaxYears;
    },
    async countQuestions(filter: ObjectiveFilter = {}, history = 0) {
      const config = {
        where: {},
        history,
      };
      config.where = filter;
      const response = await Objectives.countQuestions(config);
      return response;
    },
    async getTotalQuestions(history = 0) {
      await this.fetchObjectivesYears();
      await this.fetchObjectivesJury();

      const config = {
        where: {
          info: {
            year: {
              $lte: this.getMaxYears,
              $gte: this.getMinYears,
            },
            jury: {
              $in: this.jury || [],
            },
          },
        } as ObjectiveWhere,
        history,
      } as FetchObjectivesParams;

      const response = await Objectives.countQuestions(config);
      return response;
    },
    async fetchObjectives(config: FetchObjectivesParams) {
      const response = await Objectives.fetch(config);
      this.$state.questions = response?.data._items || [];
    },
    async fetchUserHistory(config: FetchHistoryParams) {
      config.where.origin = 'objective';
      config.sort = "[['_created', -1]]";
      const response = await Objectives.fetchQuestionsHistory(config);
      this.$state.userHistories = response?.data._items || [];
    },
  },
});
